export const getStoreDetailsPageUrl = (storeDetailsPage, store, isOpeningHoursEnabled, isOpeningHoursBreaksEnabled, isAvailableDevicesEnabled, isAvailableSticksEnabled) => {
    const storeDetailsExtendedParams = {
        shopId: `${store?.id}`,
        ...(isOpeningHoursEnabled && { isOpeningHoursEnabled: `${isOpeningHoursEnabled}` }),
        ...(isOpeningHoursBreaksEnabled && { isOpeningHoursBreaksEnabled: `${isOpeningHoursBreaksEnabled}` }),
        ...(isAvailableDevicesEnabled && { isAvailableDevicesEnabled: `${isAvailableDevicesEnabled}` }),
        ...(isAvailableSticksEnabled && { isAvailableSticksEnabled: `${isAvailableSticksEnabled}` }),
    };
    const searchParams = new URLSearchParams();
    Object.entries(storeDetailsExtendedParams || {}).forEach(([key, value]) => {
        searchParams.append(key, value);
    });
    return `${storeDetailsPage}?${searchParams.toString()}`;
};
//# sourceMappingURL=getStoreDetailsPageUrl.js.map